import React from "react";
import { useShow } from "@refinedev/core";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ShowPage } from "@/components/crud";
import { DescriptionList, DescriptionItem } from "@/components/ui/description-list";
import { IBranch } from "../../types";

export const BranchShow: React.FC = () => {
  const queryResult = useShow<IBranch>();
  const { data, isLoading } = queryResult.query;
  const record = data?.data;

  return (
    <ShowPage isLoading={isLoading}>
      <Card>
        <CardHeader>
          <CardTitle>Branch Information</CardTitle>
        </CardHeader>
        <CardContent>
          <DescriptionList columns={2} bordered>
            <DescriptionItem label="Branch Name">{record?.name}</DescriptionItem>
            <DescriptionItem label="Branch Code">{record?.code}</DescriptionItem>
            <DescriptionItem label="Company">{record?.company}</DescriptionItem>
            <DescriptionItem label="Phone">{record?.phone || "N/A"}</DescriptionItem>
            <DescriptionItem label="Email">{record?.email || "N/A"}</DescriptionItem>
            <DescriptionItem label="Status">
              <Badge variant={record?.is_active ? "success" : "destructive"}>
                {record?.is_active ? "Active" : "Inactive"}
              </Badge>
            </DescriptionItem>
            <DescriptionItem label="Main Branch">
              <Badge variant={record?.is_main ? "info" : "secondary"}>
                {record?.is_main ? "Yes" : "No"}
              </Badge>
            </DescriptionItem>
            <DescriptionItem label="Address">{record?.address || "N/A"}</DescriptionItem>
            <DescriptionItem label="Created At">
              {record?.created_at ? new Date(record.created_at).toLocaleDateString() : "N/A"}
            </DescriptionItem>
            <DescriptionItem label="Updated At">
              {record?.updated_at ? new Date(record.updated_at).toLocaleDateString() : "N/A"}
            </DescriptionItem>
          </DescriptionList>
        </CardContent>
      </Card>
    </ShowPage>
  );
};
